export const CREATE_ORDER_VALUES = [
    {
        name: 'order_name',
        label: 'orderName',
        placeholder: 'enterOrderName',
        rows: 1,
        style: {},
        type: 'text',
        className: '',
        required: true
    },
    // {
    //     name: 'description',
    //     label: 'description',
    //     placeholder: 'description',
    //     rows: 4,
    //     style: { paddingTop: "10px" },
    //     type: 'text',
    //     className: 'text-area',
    //     required: true
    // },
    {
        name: 'shipping_address',
        label: 'shippingAddress',
        rows: 1,
        style: {},
        type: 'text',
        className: '',
        required: true
    },
    // {
    //     name: 'quantity',
    //     label: 'quantity',
    //     placeholder: 'enterQuantity',
    //     rows: 1,
    //     style: {},
    //     type: 'number',
    //     className: '',
    //     required: true
    // },
    {
        name: 'vin',
        label: 'numberScanner',
        placeholder: 'EnterValue',
        rows: 1,
        style: {},  
        type: 'text',
        className: ''
    },
    {
        name: 'file_upload',
        label: 'addImage',
        placeholder: 'file-upload',
        rows: 1,
        style: {},
        type: 'file',
        className: '',
        required: false
    }
]

export const VIN_NAMES =  ['vin', 'vin number', 'identification number', 'vin #', 'vin#', 'serial number', 's/n', 'vin no:', 'identification no:', 'serial no:']

export const mapOrderToCreateOrderValues = (initialValues, data = {}) => (
    Object.keys(initialValues).reduce((acc, fieldName) => {
        if (fieldName === 'order_name') {
            acc[fieldName] = data?.name ?? data?.order_name ?? '';
            return acc;
        }

        if (fieldName === 'year') {
            acc[fieldName] = data?.make ?? data?.year ?? '';
            return acc;
        }

        if (fieldName === 'vin') {
            acc[fieldName] = data?.vin ?? data?.product_data ?? '';
            return acc;
        }

        acc[fieldName] = data?.[fieldName] ?? '';
        return acc;
    }, { ...initialValues })
);

export const buildCreateOrderPayload = (orderData = {}, options = {}) => {
    const { stringifyParts = false } = options;
    const payload = {};

    Object.entries(orderData).forEach(([key, rawValue]) => {
        if (key === 'images' || key === 'product_data') {
            return;
        }

        let value = rawValue;

        if (key === 'quantity' && value !== '' && value !== null && value !== undefined) {
            value = Number(value);
        }

        if (key === 'parts') {
            const normalizedParts = Array.isArray(value) ? value : [];
            payload[key] = stringifyParts ? JSON.stringify(normalizedParts) : normalizedParts;
            return;
        }

        if (key === 'order_name') {
            payload.name = value;
            return;
        }

        if (key === 'year') {
            payload.make = value;
            return;
        }

        payload[key] = value;
    });

    if (!Object.prototype.hasOwnProperty.call(payload, 'vin')) {
        const legacyVin = orderData?.vin ?? orderData?.product_data;

        if (legacyVin) {
            payload.vin = legacyVin;
        }
    }

    return payload;
};